import { ChevronLeft, ChevronRight } from "lucide-react";

export const DataTable = ({ columns, data, loading, page, pages, total, onPage, actions, testId = "data-table" }) => (
  <div className="border border-gray-200 bg-white" data-testid={testId}>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-200 bg-gray-50">
            {columns.map((c) => (
              <th key={c.key} className="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                {c.label}
              </th>
            ))}
            {actions && <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider text-gray-500">İşlemler</th>}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={columns.length + 1} className="px-4 py-10 text-center text-gray-400">Yükleniyor...</td></tr>
          ) : data.length === 0 ? (
            <tr><td colSpan={columns.length + 1} className="px-4 py-10 text-center text-gray-400">Kayıt bulunamadı</td></tr>
          ) : (
            data.map((row, i) => (
              <tr key={row.id || i} className="border-b border-gray-100 transition-colors duration-200 hover:bg-gray-50" data-testid={`table-row-${i}`}>
                {columns.map((c) => (
                  <td key={c.key} className="whitespace-nowrap px-4 py-3 text-[#0B1F3A]">
                    {c.render ? c.render(row) : row[c.key] ?? "-"}
                  </td>
                ))}
                {actions && <td className="px-4 py-3 text-right"><div className="flex justify-end gap-2">{actions(row)}</div></td>}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
    {pages > 1 && (
      <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3">
        <p className="text-xs text-gray-500">Toplam {total} kayıt</p>
        <div className="flex items-center gap-2">
          <button
            data-testid="pagination-prev"
            disabled={page <= 1}
            onClick={() => onPage(page - 1)}
            className="flex h-8 w-8 items-center justify-center border border-gray-200 text-[#0B1F3A] transition-colors duration-200 hover:border-[#D4AF37] disabled:opacity-40"
          >
            <ChevronLeft size={16} />
          </button>
          <span className="text-sm">{page} / {pages}</span>
          <button
            data-testid="pagination-next"
            disabled={page >= pages}
            onClick={() => onPage(page + 1)}
            className="flex h-8 w-8 items-center justify-center border border-gray-200 text-[#0B1F3A] transition-colors duration-200 hover:border-[#D4AF37] disabled:opacity-40"
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
    )}
  </div>
);
